import { render, staticRenderFns } from "./CancelBrandSubscription.vue?vue&type=template&id=7b543707&scoped=true&"
import script from "./CancelBrandSubscription.vue?vue&type=script&lang=ts&"
export * from "./CancelBrandSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./CancelBrandSubscription.vue?vue&type=style&index=0&id=7b543707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b543707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b543707')) {
      api.createRecord('7b543707', component.options)
    } else {
      api.reload('7b543707', component.options)
    }
    module.hot.accept("./CancelBrandSubscription.vue?vue&type=template&id=7b543707&scoped=true&", function () {
      api.rerender('7b543707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/CancelBrandSubscription.vue"
export default component.exports